<script setup>
import BaseFooter from "@/components/base/base-footer.vue";
import {onMounted, watch} from "vue";
import {Categories} from "@/core/api/categories.js";
import {useCategoryStore} from "@/stores/category.js";
import {useI18n} from "vue-i18n";
import {Wishlist} from "@/core/api/wishlist.js";
import {Orders} from "@/core/api/orders.js";
import {Auth} from "@/core/api/auth.js";
import {Processes} from "@/core/api/processes.js";
import {useAuthStore} from "@/stores/auth.js";
import {useCartStore} from "@/stores/cart.js";
import {useCompanyStore} from "@/stores/company.js";
import {useWishlistStore} from "@/stores/wishlist.js";
import {useRoute} from "vue-router";

const {locale} = useI18n()
const categoryStore = useCategoryStore()
const authStore = useAuthStore()
const cartStore = useCartStore()
const companyStore = useCompanyStore()
const wishlistStore = useWishlistStore()
const route = useRoute()

const checkUserAuth = async () => {
  const [res, companyRes] = await Promise.all([Auth.refresh(), Processes.getCompanyInfo()]);

  if (companyRes) {
    companyStore.setCompanyInfo(companyRes.data.parameters)
  }

  if (res.data) {
    authStore.setUser({
      user: res.data.refreshJwtToken.user,
      accessToken: res.data.refreshJwtToken.accessToken
    })

    localStorage.setItem('awe-refresh', res.data.refreshJwtToken.refreshToken)

    const currentOrder = await Orders.getOrders("PENDING", res.data.refreshJwtToken.accessToken, res.data.refreshJwtToken.user.email)
    cartStore.setCurrentOrders(currentOrder.data.orders.edges[0].node)

    const wishlistRes = await Wishlist.getWishlist(res.data.refreshJwtToken.accessToken)
    wishlistStore.wishlist = wishlistRes.data.wishlists.edges[0].node
  }
}

const getCategories = async () => {
  const res = await Categories.getCategories()
  categoryStore.setCategories(res.data.categories.edges)
}

watch(locale, async () => {
  await getCategories()
})

onMounted(async () => {
  await getCategories()
  await checkUserAuth()

  setInterval(async () => {
    await checkUserAuth()
  }, 600000)
})
</script>

<template>
  <div class="main" id="top">
<!--    <div class="main__buttons">-->
<!--      <a href="https://t.me/ecommasterweb" target="_blank">-->
<!--        <img src="@images/bottomTg.png" alt="">-->
<!--      </a>-->
<!--      <a href="https://ecommasterweb.com" target="_blank">-->
<!--        <img src="@images/bottomEcom.png" alt="">-->
<!--      </a>-->
<!--    </div>-->
    <RouterView v-slot="{ Component }" class="page">
      <Transition name="opacity" mode="out-in">
        <component :is="Component" />
      </Transition>
    </RouterView>
    <base-footer v-if="route.name !== 'checkout'" />
  </div>
</template>

<style lang="scss">
.main {
  position: relative;

  &__buttons {
    position: fixed;
    right: 20px;
    bottom: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    z-index: 1000;

    & a {
      border-radius: 17px !important;
      box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.15);
      height: 33px;
      width: 33px;
      display: grid;
      place-items: center;
      position: relative;

      & img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 43px;
      }

      &:last-child {
        width: 76px;

        & img {
          width: 86px;
        }
      }
    }
  }
}

.el-breadcrumb__inner {
  color: #F3F3F3 !important;
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: normal !important;

  &.is-link:hover {
    color: #ff0000 !important;
  }
}

.el-notification {
  box-shadow: 0 0 10px 1px #ff0000;
  border: 2px solid #ff0000;

  color: #000;
  font-size: 20px;
}
</style>
